import type { VariantProps } from 'class-variance-authority';

import { cn } from '@repo/lib/cn';
import { cva } from 'class-variance-authority';
import { File, FolderOpen } from 'lucide-react';
import { type ComponentProps } from 'react';

const fileIconVariants = cva(
  'relative grid shrink-0 place-content-center rounded-md overflow-hidden [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg]:size-4 border-border-primary border bg-accent inset-shadow-xs inset-shadow-white/10 dark:inset-shadow-white/5 before:absolute before:inset-0 before:bg-gradient-to-t before:from-transparent before:to-white/15 dark:before:to-white/6 before:pointer-events-none',
  {
    variants: {
      size: {
        sm: 'size-8',
        md: 'size-10',
        lg: 'size-12 ',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
);

interface FileIconProps extends ComponentProps<'div'>, VariantProps<typeof fileIconVariants> {
  fileExtension?: string;
}

export function FileIcon(fileIconProps: FileIconProps) {
  const { fileExtension, className, size, ...props } = fileIconProps;
  return (
    <div data-slot="file-icon" className={cn(fileIconVariants({ size, className }))} {...props}>
      <File className="text-muted-foreground" />
      <span
        aria-hidden={!fileExtension}
        className={
          'text-muted-foreground absolute right-1/5 bottom-1/5 text-[10px] font-medium select-none ' +
          '[text-shadow:1px_0_0_var(--color-accent),-1px_0_0_var(--color-accent),0_1px_0_var(--color-accent),0_-1px_0_var(--color-accent),1px_1px_0_var(--color-fill-primary),1px_-1px_0_var(--color-accent),-1px_1px_0_var(--color-accent),-1px_-1px_0_var(--color-accent)]'
        }
      >
        {fileExtension?.toLowerCase()}
      </span>
    </div>
  );
}

interface FolderIconProps extends ComponentProps<'div'>, VariantProps<typeof fileIconVariants> {}

export function FolderIcon(folderIconProps: FolderIconProps) {
  const { className, size, ...props } = folderIconProps;
  return (
    <div data-slot="folder-icon" className={cn(fileIconVariants({ size, className }))} {...props}>
      <FolderOpen className="text-muted-foreground" />
    </div>
  );
}
